import React from "react"
import PropTypes from "prop-types"
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"

import { dinero, etiquetaRecepcion, piezas } from "../helpers"

/** Pide confirmación antes de cancelar un pedido ya registrado en el día. */
const CancelOrderModal = ({ pedido, isSaving, onCancel, onConfirm }) => (
  <Modal isOpen={!!pedido} toggle={onCancel} centered>
    <ModalHeader toggle={onCancel}>Cancelar pedido</ModalHeader>
    {pedido && (
      <ModalBody>
        <p className="mb-2">¿Está seguro de cancelar este pedido?</p>
        <div>
          <strong>{pedido.proveedor}</strong> · {pedido.producto}
        </div>
        <div>
          {piezas(pedido.piezas)} pz a ${dinero(pedido.precio)} ·{" "}
          {pedido.local ? "Granja" : "Reparto"} ·{" "}
          {etiquetaRecepcion(pedido.recepcion)}
        </div>
      </ModalBody>
    )}
    <ModalFooter>
      <button type="button" className="btn btn-secondary" onClick={onCancel}>
        Volver
      </button>
      <button
        type="button"
        className="btn btn-danger"
        disabled={isSaving}
        onClick={onConfirm}
      >
        Cancelar pedido
      </button>
    </ModalFooter>
  </Modal>
)

CancelOrderModal.propTypes = {
  pedido: PropTypes.object,
  isSaving: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}

export default CancelOrderModal
